import { useId } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import type { TooltipPadding, TooltipProps } from './types';

// react-tooltip renders the padded box on an inner `.react-tooltip-content-wrapper`
// rather than the root where we set `className` on
const paddingClasses: Record<TooltipPadding, string> = {
  md: '[&_.react-tooltip-content-wrapper]:px-3! [&_.react-tooltip-content-wrapper]:py-1.5!',
  sm: '[&_.react-tooltip-content-wrapper]:px-2! [&_.react-tooltip-content-wrapper]:py-1!',
};

export function Tooltip(props: TooltipProps) {
  const fallbackId = useId();
  const id = props.id ?? fallbackId;
  const padding = paddingClasses[props.padding ?? 'md'];

  return (
    <span data-tooltip-id={id} className="inline-flex">
      <ReactTooltip
        id={id}
        className={`whitespace-normal! z-60! max-w-85! rounded-lg! bg-spark-surface! ${padding} font-normal! text-spark-text-primary! text-xs! shadow-md! transition-opacity! duration-200!`}
        opacity={1}
        border="1px solid var(--color-spark-border-default)"
        positionStrategy="fixed"
        clickable
        delayHide={200}
      >
        {props.content}
      </ReactTooltip>
      {props.children}
    </span>
  );
}
